<template>
  <!-- 帮助弹框 -->
  <ModalHelper />

  <!-- 通知顶部弹框 -->
  <notification-popup />

  <!-- 首页点击加号弹框 -->
  <ModalHomeAdd />

  <!-- 更新弹框 -->
  <ReloadPrompt />

  <!-- 获得物品弹框:暂时还未使用 -->
  <ModalSwapReceived />

  <!-- 购买单个资源弹框：已废弃 -->
  <!-- <NSFWModalBuyItem /> -->
  <ChatPrepare />

  <!-- 登录弹框 -->
  <LoginPopup />

  <!-- 年龄确认弹框 -->
  <NSFWModalConfirmAge
    v-model:show="userStore.nsfwAgeConfirm.show"
    @enter="
      userStore.nsfwAgeConfirm.callback && userStore.nsfwAgeConfirm.callback()
    "
  />

  <!-- 回复emoji弹框 -->
  <emoji-vote-popup
    v-model:show="replyStore.showEmojiPopup"
    :to-vote-reply="replyStore.emojiReplyTarget"
  />

  <!-- 选择其他mate弹框 -->
  <SelectAnotherMateForChat
    v-if="userStore.isLogin"
    v-model:show="uiStore.showAnotherMateSelector"
  />

  <!-- 翻译弹框 -->
  <TranslateLangSelectionPopup />

  <!-- 订阅弹框 -->
  <ModalToSubscribe />

  <!-- 兑换码弹框 -->
  <RedeemPopup />

  <!-- 小程序弹框 -->
  <MiniProgram />

  <!-- 预览图片 -->
  <MediaPreview />

  <!-- 富文本编辑器 -->
  <RichTextEditor />

  <!-- 输入框 -->
  <ModalTextInput />

  <!-- 新站内信 -->
  <ModalNewSiteMessage />

  <!-- 水晶不足 -->
  <ModalCrystalNotEnough />

  <!-- 能量块不足 -->
  <ModalPowerNotEnough />

  <!-- 进入APP -->
  <ModalEnterApp />
  <JoinInteractivePoolInform />

  <!-- 编辑回复 -->
  <ModalReplyEdit />

  <VanActionSheet
    v-model:show="modalStore.showGlobalActionSheet"
    :actions="modalStore.globalActionSheetList"
    @select="modalStore.showGlobalActionSheet = false"
  />

  <ModalCustomActionSheet />

  <ModalSelectModel />
</template>

<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import NotificationPopup from "@/components/mobile/popup/NotificationPopup.vue";
import ModalHomeAdd from "@/views/Home/components/ModalHomeAdd.vue";
import ModalSwapReceived from "@/views//NSFW/Modal/ModalSwapReceived.vue";
import ChatPrepare from "@/components/mobile/chat/popup/ChatPrepare.vue";
import LoginPopup from "@/components/mobile/login/popup/LoginPopup.vue";
import NSFWModalConfirmAge from "@/views/NSFW/Modal/NSFWModalConfirmAge.vue";

import { useReply } from "@/stores/reply";
import { useUI } from "@/stores/ui";
import ModalToSubscribe from "@/views/NSFW/Modal/ModalToSubscribe.vue";
import RedeemPopup from "@/components/mobile/info/RedeemPopup.vue";
import MiniProgram from "@/components/mobile/common/MiniProgram.vue";
import ModalTextInput from "./ModalTextInput.vue";
import ModalNewSiteMessage from "./ModalNewSiteMessage.vue";
import { useGlobalModal } from "@/stores/globalModal";
import ModalCustomActionSheet from "./ModalCustomActionSheet.vue";
import ModalSelectModel from "./ModalSelectModel.vue";
const userStore = useGlobalUser();
const replyStore = useReply();
const uiStore = useUI();
const modalStore = useGlobalModal();
</script>
